//Enrollee
export const ENROLLEE_LOGIN_SUCCESS = "ENROLLEE_LOGIN_SUCCESS";
export const ENROLLEE_LOGOUT_SUCCESS = "ENROLLEE_LOGOUT_SUCCESS";

export const ENROLLEE_LOAD_SUCCESS = "ENROLLEE_LOAD_SUCCESS";
export const ENROLLEE_UPDATE_SUCCESS = "ENROLLEE_UPDATE_SUCCESS";
export const CLIENT_UPDATE_SUCCESS = "CLIENT_UPDATE_SUCCESS";
export const ENROLLEE_SCHEDULE_SUCCESS = "ENROLLEE_SCHEDULE_SUCCESS";

//Vehicles
export const LOAD_VEHICLE_SUCCESS = "LOAD_VEHICLE_SUCCESS";
export const UPDATE_VEHICLE_SUCCESS = "UPDATE_VEHICLE_SUCCESS";
export const SAVE_VEHICLE_SUCCESS = "SAVE_VEHICLE_SUCCESS";

//Appointments
export const LOAD_APPOINTMENTS_SUCCESS = "LOAD_APPOINTMENTS_SUCCESS";
export const SAVE_APPOINTMENT_OPTIMISTIC = "SAVE_APPOINTMENT_OPTIMISTIC";
export const DELETE_APPOINTMENT_OPTIMISTIC = "DELETE_APPOINTMENT_OPTIMISTIC";
export const DELETE_APPOINTMENT_LAST_OPTIMISTIC =
  "DELETE_APPOINTMENT_LAST_OPTIMISTIC";
export const CREATE_APPOINTMENT_SUCCESS = "CREATE_APPOINTMENT_SUCCESS";
export const LOAD_LOCATIONS_SUCCESS = "LOAD_LOCATIONS_SUCCESS";
export const LOAD_AVAILABLE_DATES_SUCCESS = "LOAD_AVAILABLE_DATES_SUCCESS";
export const LOAD_AVAILABLE_HOURS_SUCCESS = "LOAD_AVAILABLE_HOURS_SUCCESS";
export const RESET_LOCATIONS_SUCCESS = "RESET_LOCATIONS_SUCCESS";
export const RESET_AVAILABLE_DATES_SUCCESS = "RESET_AVAILABLE_DATES_SUCCESS";
export const RESET_AVAILABLE_HOURS_SUCCESS = "RESET_AVAILABLE_HOURS_SUCCESS";
export const RESET_APPOINTMENTS_SUCCESS = "RESET_APPOINTMENTS_SUCCESS";
export const LOAD_AVAILABLE_SERVICES_SUCCESS =
  "LOAD_AVAILABLE_SERVICES_SUCCESS";
export const RESET_AVAILABLE_SERVICES_SUCCESS =
  "RESET_AVAILABLE_SERVICES_SUCCESS";

//User
export const LOAD_STATES_SUCCESS = "LOAD_STATES_SUCCESS";

export const BEGIN_API_CALL = "BEGIN_API_CALL";
export const API_CALL_ERROR = "API_CALL_ERROR";

export const SET_REFERRAL_SITE = "SET_REFERRAL_SITE";
